import React from 'react';
import { ActiveStateTokens, BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { Image, View, } from 'react-native';
import Typography from '../typography/Typography';
const AvatarBase = ({ size, uri, borderRadius = BorderRadiusTokens.BR4, borderWidth, borderColor, 
//bgColor,
initialLetter, overlap = false, active, }) => {
    const theme = ThemeProvider.getTheme();
    const sizeValue = theme.avatarSize[size];
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const borderColorValue = theme.colors[borderColor];
    if (!uri || !size)
        return React.createElement(React.Fragment, null);
    const styleProps = React.useMemo(() => ({
        height: sizeValue,
        width: sizeValue,
        borderRadius: borderRadiusValue,
        borderColor: borderColorValue,
        borderWidth: 0,
        marginLeft: overlap ? -(sizeValue / 4) : 0,
    }), [
        sizeValue,
        borderColorValue,
        borderColor,
        borderWidth,
        overlap,
        borderRadius,
    ]);
    const activeStyleProps = React.useMemo(() => ({
        position: 'absolute',
        left: sizeValue / 2 + sizeValue / 4,
        top: sizeValue / 2 + sizeValue / 8,
        width: sizeValue / 4,
        height: sizeValue / 4,
        borderRadius: sizeValue / 8,
        borderWidth: 2,
        borderColor: borderColorValue,
        backgroundColor: theme.colors[ColorTokens.Success_100],
    }), [sizeValue, borderColor]);
    const letterStyleProps = React.useMemo(() => ({
        width: sizeValue,
        height: sizeValue,
        borderRadius: sizeValue,
        backgroundColor: borderColorValue,
    }), [sizeValue, borderColor]);
    return (React.createElement(React.Fragment, null,
        initialLetter && (React.createElement(View, { style: [
                {
                    alignItems: 'center',
                    justifyContent: 'center',
                },
                letterStyleProps,
            ] },
            React.createElement(Typography, { label: initialLetter, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.XL, color: ColorTokens.White }))),
        React.createElement(React.Fragment, null, initialLetter == '' && (React.createElement(Image, { style: styleProps, source: { uri } }))),
        active &&
            active === ActiveStateTokens.ACTIVE && (React.createElement(View, { style: activeStyleProps }))));
};
export default React.memo(AvatarBase);
export { AvatarBase };
